import React, { useState } from "react";
import ClientPortalAppLayout from "../../Components/Molecules/ClientPortalAppLayout";
import TabsSelector, { TabKeyValue } from "../../Components/Atoms/TabsSelector";
import ClientPortalCustomerManagePaymentMethods from "./ClientPortalCustomerManagePaymentMethods";
import { useParams } from "react-router-dom";
import MessageBanner from "../../Components/Molecules/PaymentsAppHeader/MessageBanner";
import ClientPortalCustomerDetailInvoiceList from "./ClientPortalCustomerDetailInvoiceList";

const Tabs: TabKeyValue[] = [
  { key: "invoice", displayValue: "Invoice" },
  { key: "payment_method", displayValue: "Payment Methods" }
];

const ClientPortalCustomerDetailPage: React.FC = () => {
  const [currentActiveTab, setCurrentActiveTab] = useState<string>("invoice");
  const { customerId } = useParams();

  if (customerId === undefined) {
    throw new Error(`Customer ID not found in URL ${window.location.href}`);
  }

  return (
    <ClientPortalAppLayout>
      <MessageBanner />
      <div>
        <TabsSelector
          tabs={Tabs}
          currentActiveTab={currentActiveTab}
          setCurrentActiveTab={setCurrentActiveTab}
        />
        {currentActiveTab === "invoice" ? (
          <ClientPortalCustomerDetailInvoiceList />
        ) : (
          <ClientPortalCustomerManagePaymentMethods customerId={customerId} />
        )}
      </div>
    </ClientPortalAppLayout>
  );
};

export default ClientPortalCustomerDetailPage;
